module.exports = __webpack_public_path__ + "media/weber_start.0cb7b70e.webm";